// User object that is shared publicly

import { makeObservable } from 'mobx'
import type { MobxDocument } from '../firestore-mobx'
import {
  ObservableModelWithDecorators,
  emptyCollection,
  emptyModel,
} from '../firestore-mobx/model'
import type { FirestoreRoomStateCollaborationData } from '../firestore/RoomStateCollaborationData'
import { empty } from '../firestore/RoomStateCollaborationData'
import type { FirebaseRepository } from './FirebaseRepository'

export class RoomStateCollaborationData extends ObservableModelWithDecorators<FirestoreRoomStateCollaborationData> {
  static empty(repository: FirebaseRepository) {
    return emptyModel(repository, this, empty)
  }

  static emptyCollection(repository: FirebaseRepository) {
    return emptyCollection(repository, this, empty)
  }

  constructor(
    repository: FirebaseRepository,
    doc: MobxDocument<FirestoreRoomStateCollaborationData>
  ) {
    super(repository, doc)

    makeObservable(this)
  }
}
